ISMDSPlugin.define('src/js/util/util',['_'], function (_) {
  var util = {};

  util.inRange = function (actual, start, end) {
    var compareValue = Number(actual);
    var isValid = true;
    if (!_.isFinite(compareValue)) {
      throw new TypeError(actual + ' must be a numeric value.');
    }

    isValid = isValid && compareValue >= start;
    isValid = isValid && compareValue <= end;
    return isValid;
  };

  util.min = function (first, second) {
    if (first && second) {
      return Math.min(first, second);
    }
    if (!first) {
      return second;
    }
    if (!second) {
      return first;
    }
  };

  util.max = function (first, second) {
    if (first && second) {
      return Math.max(first, second);
    }
    if (!first) {
      return second;
    }
    if (!second) {
      return first;
    }
  };

  util.pluck = function (array, property) {
    var result = [],
      length = array.length,
      i;
    for (i = 0; i < length; ++i) {
      result.push(array[i][property]);
    }

    return result;
  };

  return util;
});

